import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Prediction() {
    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Prediction & Analytics</span>
                    </div>
                </section>


                <section class="pad bank-benefits default margin-top-content">

                    <div class="content normal">
                        <div data-lavalamp=""></div>

                        <div class="img-frame img-width40">
                            <img src="images/nugenesisou/abt-illustration-24.png" alt="" />
                        </div>

                        <div class="data">
                            <div class="text">
                                <h3 class="title">AI Price Prediction Technology</h3>

                                <p class="subtitle">
                                    Nugenesis NAVIS AI Price Predition Technology operates 24 hours a day analysing crypto currencies to identify trends in the market and cost estimation.
                                </p>

                            </div>
                            <br></br>
                            <h3 class="title">AI Service Monitoring</h3>
                            <div class="btns marign-low-bottom-up">
                                <a href="document/AI-Service-MonitoringMonthly-summary.pdf" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>

                            <div class="text">
                                <h3 class="title">Price Predition Tosend</h3>
                            </div>
                            <div class="btns marign-low-bottom-up">
                                <a href="document/Price-Prediction-Tosend.pdf" target="_blank" data-patt="track-btn" class="">Download</a>
                            </div>


                        </div>


                    </div>

                </section>

                <section class="pad bank-benefits white">
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">Price Predition Sample</h3>

                            </div>
                        </div>
                        <div class="img-frame">
                            <img src="images/nugenesisou/abt-illustration-25.jpeg" alt="" />
                        </div>
                    </div>

                </section>



                <section class="pad bank-benefits default">
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">Nucoin Mining Brochure</h3>
                                <p class="subtitle">Mining and Staking Summary
                                </p>
                                <div class="btns">
                                    <a href="document/NU-COIN-mining-brouchure-1.pdf" target="_blank" data-patt="track-btn" class="">
                                        Download</a>
                                </div>
                            </div>
                            <br></br>
                            <br></br>
                            <div class="text">
                                <h3 class="title">Nugenesis Formulas </h3>
                                <p class="subtitle">Nugeneiss Formulation for 121 years</p>

                                <div class="btns">
                                    <a href="document/NuGenesis-Tokenomics-NUC-VS-NUC2.xlsx" target="_blank" data-patt="track-btn" class="">
                                        Download</a>
                                </div>



                            </div>
                        </div>
                        <div class="img-frame">
                            <img src="images/nugenesisou/abt-illustration-1.png" alt="" />
                        </div>
                    </div>
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">JUST SOCIAL WRITE UP</h3>
                                <p class="subtitle">THE DECENTRALISED SOCIAL MEDIA PLATFORM THATEMPOWERS
                                    USERS TO REALISE THEIR VALUE </p>
                                <div class="btns">
                                    <a href="document/JUST-SOCIAL-WRITE-UP2.docx" target="_blank" data-patt="track-btn" class="">
                                        Download</a>
                                </div>
                            </div>

                            <br></br>


                            <div class="text">
                                <h3 class="title">Value</h3>
                                <p class="subtitle">Users are starting to realise that their private data is valuable; that their spending patterns, interests,opinions and sentiments are powerful signals that are marketable </p>

                            </div>
                            <br></br>
                            <div class="text">
                                <h3 class="title">Blockchain Hub</h3>
                                <p class="subtitle">Layer 1 blockchain that parallel processes with the other
                                    NuGenesis blockchains and are bridged to all major
                                    blockchain languages, systems and interoperableility </p>

                            </div>
                            <br></br>
                            <div class="text">
                                <h3 class="title">Serialisation</h3>
                                <p class="subtitle">JS blockchain can serialise all digital assets created
                                    upon it with the consequence that these assets can be
                                    traced if lost or stolen </p>

                            </div>
                            <br></br>
                            <div class="text">
                                <h3 class="title">Just Social Coin</h3>
                                <p class="subtitle">JS coin is the reward for services rendered by the user to
                                    the community and can be exchanged for services
                                    offered by other usersin the JS ecosphere </p>

                            </div>

                        </div>
                        <div class="img-frame">
                            <img src="images/nugenesisou/abt-illustration-26.png" alt="" />
                        </div>
                    </div>



                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">NUGENESIS PLATFORM  ANALYTICS </h3>
                                <p class="subtitle">Notification Platform
                                    Documentation</p>
                                <div class="btns marign-low-bottom-up30">
                                    <a href="document/Notification-Platform-Documentation-Sendto.pdf" target="_blank" data-patt="track-btn" class="">
                                        Download</a>
                                </div>
                            </div>

                            <div class="text">

                                <p class="subtitle">NU Genesis AI Projects' Status</p>

                                <div class="btns marign-low-bottom-up30">
                                    <a href="document/NUCOIN-NUGenesisAIProjects-Status-160622-1353.pdf" target="_blank" data-patt="track-btn" class="">
                                        Download</a>
                                </div>

                            </div>


                            <div class="text">

                                <p class="subtitle">Blockchain Infrastructure</p>

                                <div class="btns marign-low-bottom-up30">
                                    <a href="document/NUC-Blockchain-Cloud-Infrastructure.pdf" target="_blank" data-patt="track-btn" class="">
                                        Download</a>
                                </div>

                            </div>


                            <div class="text">

                                <p class="subtitle">Treasury Model</p>

                                <div class="btns marign-low-bottom-up30">
                                    <a href="document/Treasury_Model_v3.drawio.pdf" target="_blank" data-patt="track-btn" class="">
                                        Download</a>
                                </div>

                            </div>
                        </div>
                        <div class="img-frame">
                            <img src="images/nugenesisou/abt-illustration-27.png" alt="" />
                        </div>
                    </div>
                </section>


                <section class="pad bank-benefits white">
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">NUGENESIS TRADE MARKS & PATENTS</h3>
                                <p class="subtitle">
                                    Rights Registration <br></br> <br></br>
                                    CLIK HERE <br></br> <br></br>
                                    NUGENESIS TRADE <br></br> <br></br>
                                    MARKS & PATENTS <br></br> <br></br>
                                    Adverse Report <br></br> <br></br>
                                    MetaRealm Trademark <br></br> <br></br>
                                    EWA TradeMark <br></br> <br></br>
                                    LedgerX TradeMark <br></br> <br></br>
                                    MetaRealm TradeMark Details <br></br> <br></br>

                                </p>
                                <div class="btns">
                                    <a href="document/2212779-IP-Right-Registered.pdf" target="_blank" data-patt="track-btn" class="">Download</a>
                                </div>
                            </div>
                        </div>
                        <div class="img-frame  img-width40">
                            <img src="images/nugenesisou/pr-illustration-10.png" alt="" />
                        </div>
                    </div>

                </section>

            </main>
            <Footer />
        </>
    )
}